// extracted by mini-css-extract-plugin
export default {"cls1":"HH892VVvP_j19eStk2aw","cls2":"n9NxB9l1bNhYuXJkhNU7 HH892VVvP_j19eStk2aw"};